import { NgModule } from '@angular/core';

import { CoreDateInputDirective } from '@core/directives/core-date-input/core-date-input.directive';
import { FeatherIconDirective } from '@core/directives/core-feather-icons/core-feather-icons';
import { RippleEffectDirective } from '@core/directives/core-ripple-effect/core-ripple-effect.directive';
import { Ng2FlatpickrPeriodoDirective } from '@core/directives/ng2-flatpickr-periodo/ng2-flatpickr-periodo.directive';
import { NgbdSortableHeader } from './table-sort/sort.directive';

@NgModule({
  declarations: [RippleEffectDirective, FeatherIconDirective, NgbdSortableHeader, CoreDateInputDirective, Ng2FlatpickrPeriodoDirective],
  exports: [RippleEffectDirective, FeatherIconDirective, NgbdSortableHeader, CoreDateInputDirective, Ng2FlatpickrPeriodoDirective]
})
export class CoreDirectivesModule {}
